@if (loading()) {
	<nz-spin nzSimple nzSize="large"></nz-spin>
} @else {
	<app-setup-wizard-dynamic-table
		[enableEditButton]="enableEditButton()"
		[enableToggleDisableButton]="enableToggleDisableButton()"
		[enableRemoveButton]="enableRemoveButton()"
		[enableResetButton]="enableResetButton()"
		[selectedRow]="selectedRow()"
		[rows]="rows()"
		[pageSize]="pageSize()"
		[columns]="columns()"
		(onToggleDisable)="onToggleDisableClick($event)"
		(onRemove)="onRemoveClick($event)"
		(onReset)="onResetClick($event)"
		(onEdit)="onEditClick($event)"
	>
		<!-- Header templates (defines order/keys) -->
		<ng-template [appHeaderColumn]="LessonCsvKeys.ssoLessonId">
			{{ LESSON_CSV_LABELS[LessonCsvKeys.ssoLessonId] }}
		</ng-template>
		<ng-template [appHeaderColumn]="LessonCsvKeys.defaultLangId">
			{{ LESSON_CSV_LABELS[LessonCsvKeys.defaultLangId] }}
		</ng-template>
		<ng-template [appHeaderColumn]="LessonCsvKeys.displayOrder">
			{{ LESSON_CSV_LABELS[LessonCsvKeys.displayOrder] }}
		</ng-template>
		<ng-template [appHeaderColumn]="LessonCsvKeys.enName">
			{{ LESSON_CSV_LABELS[LessonCsvKeys.enName] }}
		</ng-template>
		<ng-template [appHeaderColumn]="LessonCsvKeys.active">
			{{ LESSON_CSV_LABELS[LessonCsvKeys.active] }}
		</ng-template>

		<ng-template appHeaderColumn="status">Status</ng-template>

		<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
		<ng-template [appRowColumn]="LessonCsvKeys.ssoLessonId" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="LessonCsvKeys.ssoLessonId"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="LessonCsvKeys.defaultLangId" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="LessonCsvKeys.defaultLangId"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="LessonCsvKeys.displayOrder" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="LessonCsvKeys.displayOrder"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="LessonCsvKeys.enName" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="LessonCsvKeys.enName"></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="LessonCsvKeys.active" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="LessonCsvKeys.active"></app-setup-wizard-before-after>
		</ng-template>

		<ng-template appRowColumn="status" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after-status [data]="row"></app-setup-wizard-before-after-status>
		</ng-template>
	</app-setup-wizard-dynamic-table>
}
